import React from "react";
import { PermissionsTable } from "../../AddOrganisation/components/PermissionsTable";
import { AddMemberPanel } from "../../AddOrganisation/components/AddMemberPanel";

const GroupUserPermission = ({ refetch, setRefetch }) => {
  return (
    <div className="w-full h-full max-md:mt-8 max-md:max-w-full">
      <div className="h-full max-md:max-w-full">
        <div className="flex h-full gap-5 max-md:flex-col">
          <div className="w-full h-full max-md:ml-0 max-md:w-full">
            <PermissionsTable refetch={refetch} setRefetch={setRefetch} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupUserPermission;
